import { Button, Card, CardContent,Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  root: {
    minWidth: 275,
    maxWidth: 500,
    margin: "auto"
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
});

const unixTimeToString = (unixTime) => {
  let date = new Date(unixTime*1000);
  return (date.getMonth()+1)+"/"+date.getDate()+"/"+date.getFullYear();
}

export default function TourneyCard(props){
  const classes = useStyles();

  return (<Card className={classes.root}>
    <CardContent>
      <Typography color="textPrimary">
        {props.tournament.name}
      </Typography>
      <Typography color="textSecondary">
        {unixTimeToString(props.tournament.startAt)}
      </Typography>
      <table style={{width: "100%"}}>
      <tr>
        <td>Entrants: {props.tournament.entrants} </td>
        <td>Tweets: {props.tournament.count} </td>
      </tr>
      </table>
      <Button variant="outlined"><a href={props.tournament.link}>LINK</a></Button>
    </CardContent>
  </Card>);
}
